<template>
<v-menu v-model="menuKeyword" offset-y lazy :close-on-content-click="false">
  <template v-slot:activator="{ on }">
    <v-btn flat v-on="on" style="min-width:24px;">
      <div>
        <v-icon :small="available">search</v-icon><br>
        <span v-if="available">{{$root.searchKeyword}}</span>
      </div>
    </v-btn>
  </template>
  <v-text-field solo hide-details single-line v-model="$root.searchKeyword" append-icon="search" :placeholder="$t('device.search')" clearable></v-text-field>
</v-menu>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'SearchKeywordMenu',
  mixins: [UserAuth],
  data() {
    return {
      menuKeyword: false,
    }
  },
  computed: {
    available() {
      return !this.menuKeyword && !!this.$root.searchKeyword;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/SearchKeywordMenu.vue